import React from 'react';
import PropTypes from 'prop-types';
import * as _ from 'lodash';

const AdFacilities = ({ facilities }) => {
    if (!_.isEmpty(facilities)) {
        return (
            <div className="border-b-2 border-bluegray-200 py-32">
                <h3>Fasiliteter</h3>
                <div className="grid grid-cols-2 mt-16">
                    {facilities.map(facility => {
                        return (
                            <div key={facility}>
                                <p>{facility}</p>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
    return null;
};

AdFacilities.propTypes = {
    facilities: PropTypes.arrayOf(PropTypes.string),
};

export default AdFacilities;
